import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Badge } from "./ui/badge"
import { Button } from "./ui/button"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog"
import { Input } from "./ui/input"
import { Textarea } from "./ui/textarea"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select"
import { Edit, Save, Plus, Search } from "lucide-react"
import { useState } from "react"
import { pruebasDisponibles as pruebasBase } from "./PruebaSelector"
import { useTienePermiso } from "../App"

interface Prueba {
  id: string
  nombre: string
  tipo: "Fisico" | "Quimico"
  descripcion: string
  tiempoEstimado: string
}

const mockPruebas: Prueba[] = [
  {
    id: "1",
    nombre: "NMX-A-172-INNTEX-2012 RESISTENCIA A LA ABRASIÓN PLANA TABER",
    tipo: "Fisico",
    descripcion: "Determinación de la resistencia a la abrasión mediante el método Taber",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "2",
    nombre: "NMX-A-12945-3-INNTEX-2020 DETERMINACION DE FRISAS, VELLOSIDAD Y EMARAÑAMIENTO",
    tipo: "Fisico", 
    descripcion: "Evaluación de características superficiales del tejido",
    tiempoEstimado: "1 día"
  },
  {
    id: "3",
    nombre: "ANÁLISIS QUÍMICO CUALITATIVO Y CUANTITATIVO",
    tipo: "Quimico",
    descripcion: "Identificación y cuantificación de componentes químicos",
    tiempoEstimado: "3-5 días"
  },
  {
    id: "4",
    nombre: "NMX-A-134-INNTEX-2013 DENSIDAD DE TEJIDO DE PUNTO",
    tipo: "Fisico",
    descripcion: "Medición de la densidad en tejidos de punto",
    tiempoEstimado: "1 día"
  },
  {
    id: "5",
    nombre: "NMX-A-5077-INNTEX-2015 / NMX-A-6330-INNTEX-2015 CAMBIOS DIMENSIONALES",
    tipo: "Fisico",
    descripcion: "Evaluación de cambios dimensionales en textiles",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "6",
    nombre: "NMX-A-229-1982 Determinación del pH y Δ pH de un extracto acuoso de cuero",
    tipo: "Quimico",
    descripcion: "Medición de pH en extractos acuosos de cuero",
    tiempoEstimado: "1 día"
  },
  {
    id: "7",
    nombre: "NMX-A-3801-INNTEX-2012 PESO DE LA TELA (METODO 5)",
    tipo: "Fisico",
    descripcion: "Determinación del peso por unidad de área de la tela",
    tiempoEstimado: "1 día"
  },
  {
    id: "8",
    nombre: "NMX-A-4920-INNTEX-2017 RESISTENCIA AL HUMEDECIMIENTO SUPERFICIAL (MÉTODO DE ROCÍO)",
    tipo: "Fisico",
    descripcion: "Evaluación de la resistencia al humedecimiento superficial",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "9",
    nombre: "NMX-A-109-INNTEX-2012 RESISTENCIA AL RASGADO",
    tipo: "Fisico",
    descripcion: "Determinación de la resistencia al rasgado de textiles",
    tiempoEstimado: "1 día"
  },
  {
    id: "10",
    nombre: "NMX-A-230-1982 Determinación del contenido de cromo",
    tipo: "Quimico",
    descripcion: "Cuantificación del contenido de cromo en muestras",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "11",
    nombre: "NMX-A-7211/2-INNTEX-2015 DENSIDAD DE TEJIDO PLANO (METODO A)",
    tipo: "Fisico",
    descripcion: "Medición de la densidad en tejidos planos",
    tiempoEstimado: "1 día"
  },
  {
    id: "12",
    nombre: "NMX-A-228-1982 Determinación de cenizas totales y cenizas insolubles en agua",
    tipo: "Quimico",
    descripcion: "Determinación cuantitativa de cenizas totales e insolubles",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "13",
    nombre: "NMX-A-225-1982 Determinación de humedad en cuero",
    tipo: "Quimico", // <-- Cambiado de Fisico a Quimico
    descripcion: "Medición del contenido de humedad en cuero",
    tiempoEstimado: "1 día"
  },
  {
    id: "14",
    nombre: "NMX-A-073-INNTEX-2005 SOLIDEZ DEL COLOR AL FROTE",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color al frote",
    tiempoEstimado: "1 día"
  },
  {
    id: "15",
    nombre: "TIPO DE TEJIDO MET-7.2-11",
    tipo: "Fisico",
    descripcion: "Identificación y clasificación del tipo de tejido",
    tiempoEstimado: "1 día"
  },
  {
    id: "16",
    nombre: "NMX-A-105-E04-INNTEX-2019 SOLIDEZ DEL COLOR AL SUDOR",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color al sudor",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "17",
    nombre: "NMX-A-9073/1-INNTEX-2018 MASA DE NO TEJIDOS",
    tipo: "Fisico",
    descripcion: "Determinación de la masa por unidad de área de no tejidos",
    tiempoEstimado: "1 día"
  },
  {
    id: "18",
    nombre: "NMX-A-083-INNTEX-2020 EVALUACIÓN DE CONFECCIÓN Y DIMENSIÓN DE PRENDAS",
    tipo: "Fisico",
    descripcion: "Evaluación de características de confección y dimensionales",
    tiempoEstimado: "1-2 días"
  },
  {
    id: "19",
    nombre: "NMX-A-105-C06-INNTEX-2015 SOLIDEZ DEL COLOR AL LAVADO DOMESTICO E INDUSTRIAL",
    tipo: "Quimico",
    descripcion: "Evaluación de la solidez del color al lavado",
    tiempoEstimado: "2-3 días"
  },
  {
    id: "20",
    nombre: "NMX-A-275/5-INNTEX-2000 DENSIDAD LINEAL DE HILOS EXTRAIDOS DE LA TELA (METODO A)",
    tipo: "Fisico",
    descripcion: "Medición de la densidad lineal de hilos",
    tiempoEstimado: "1 día"
  },
  {
    id: "21",
    nombre: "TIPO DE LIGAMENTO MET-7.2-12",
    tipo: "Fisico",
    descripcion: "Identificación del tipo de ligamento en tejidos",
    tiempoEstimado: "1 día"
  },
  {
    id: "22",
    nombre: "TIPO DE ACABADO MET-7.2-19",
    tipo: "Fisico",
    descripcion: "Identificación y caracterización del tipo de acabado",
    tiempoEstimado: "1 día"
  },
  {
    id: "23",
    nombre: "NMX-A-221-1982 Determinación de las grasas y otros materiales solubles por extracción con cloruro de metileno",
    tipo: "Quimico",
    descripcion: "Cuantificación de grasas y materiales solubles mediante extracción",
    tiempoEstimado: "2-4 días"
  }
]

interface AddPruebaDialogProps {
  onAdd: (newPrueba: Omit<Prueba, 'id'>) => void
}

function AddPruebaDialog({ onAdd }: AddPruebaDialogProps) {
  const [newPrueba, setNewPrueba] = useState<Omit<Prueba, 'id'>>({
    nombre: "",
    tipo: "Fisico",
    descripcion: "",
    tiempoEstimado: ""
  })
  const [isOpen, setIsOpen] = useState(false)

  const handleSave = () => {
    if (newPrueba.nombre.trim() && newPrueba.descripcion.trim() && newPrueba.tiempoEstimado.trim()) {
      onAdd(newPrueba)
      setNewPrueba({
        nombre: "",
        tipo: "Fisico",
        descripcion: "",
        tiempoEstimado: ""
      })
      setIsOpen(false)
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          Agregar Prueba
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Agregar Nueva Prueba</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Complete los campos para agregar una nueva prueba.
        </DialogDescription>
        <div className="space-y-4">
          <div>
            <label className="text-muted-foreground">Nombre de la Prueba *</label>
            <Textarea
              value={newPrueba.nombre}
              onChange={(e) => setNewPrueba({ ...newPrueba, nombre: e.target.value })}
              className="mt-1"
              rows={2}
              placeholder="Ingrese el nombre completo de la prueba"
            />
          </div>
          <div>
            <label className="text-muted-foreground">Tipo *</label>
            <Select
              value={newPrueba.tipo}
              onValueChange={(value: "Fisico" | "Quimico") => 
                setNewPrueba({ ...newPrueba, tipo: value })
              }
            >
              <SelectTrigger className="mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Fisico">Físico</SelectItem>
                <SelectItem value="Quimico">Químico</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-muted-foreground">Descripción *</label>
            <Textarea
              value={newPrueba.descripcion}
              onChange={(e) => setNewPrueba({ ...newPrueba, descripcion: e.target.value })}
              className="mt-1"
              rows={3}
              placeholder="Describa brevemente la prueba y su propósito"
            />
          </div>
          <div>
            <label className="text-muted-foreground">Tiempo Estimado *</label>
            <Input
              value={newPrueba.tiempoEstimado}
              onChange={(e) => setNewPrueba({ ...newPrueba, tiempoEstimado: e.target.value })}
              className="mt-1"
              placeholder="ej. 1-2 días"
            />
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={() => setIsOpen(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSave}
              disabled={!newPrueba.nombre.trim() || !newPrueba.descripcion.trim() || !newPrueba.tiempoEstimado.trim()}
            >
              <Save className="h-4 w-4 mr-2" />
              Agregar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

interface EditPruebaDialogProps {
  prueba: Prueba
  onSave: (updatedPrueba: Prueba) => void
}

function EditPruebaDialog({ prueba, onSave }: EditPruebaDialogProps) {
  const [editedPrueba, setEditedPrueba] = useState<Prueba>(prueba)
  const [isOpen, setIsOpen] = useState(false)

  const handleSave = () => {
    onSave(editedPrueba)
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="w-full mt-4">
          <Edit className="h-4 w-4 mr-2" />
          Editar
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Editar Prueba</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Complete los campos para editar la prueba.
        </DialogDescription>
        <div className="space-y-4">
          <div>
            <label className="text-muted-foreground">Nombre de la Prueba</label>
            <Textarea
              value={editedPrueba.nombre}
              onChange={(e) => setEditedPrueba({ ...editedPrueba, nombre: e.target.value })}
              className="mt-1"
              rows={2}
            />
          </div>
          <div>
            <label className="text-muted-foreground">Tipo</label>
            <Select
              value={editedPrueba.tipo}
              onValueChange={(value: "Fisico" | "Quimico") => 
                setEditedPrueba({ ...editedPrueba, tipo: value })
              }
            >
              <SelectTrigger className="mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Fisico">Físico</SelectItem>
                <SelectItem value="Quimico">Químico</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-muted-foreground">Descripción</label>
            <Textarea
              value={editedPrueba.descripcion}
              onChange={(e) => setEditedPrueba({ ...editedPrueba, descripcion: e.target.value })}
              className="mt-1"
              rows={3}
            />
          </div>
          <div>
            <label className="text-muted-foreground">Tiempo Estimado</label>
            <Input
              value={editedPrueba.tiempoEstimado}
              onChange={(e) => setEditedPrueba({ ...editedPrueba, tiempoEstimado: e.target.value })}
              className="mt-1"
              placeholder="ej. 1-2 días"
            />
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={() => setIsOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSave}>
              <Save className="h-4 w-4 mr-2" />
              Guardar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export function PruebasView({ user }: { user: { email: string } }) {
  // Siempre usa la lista base local, nunca la prop
  const [pruebasState, setPruebas] = useState<any[]>(pruebasBase)
  const [searchTerm, setSearchTerm] = useState("")
  const isAdmin = useTienePermiso('administrar_catalogo')

  const handleSavePrueba = (updatedPrueba: Prueba) => {
    setPruebas(prev => prev.map(p => p.id === updatedPrueba.id ? updatedPrueba : p))
  }

  const handleAddPrueba = (newPrueba: Omit<Prueba, 'id'>) => {
    const newId = (Math.max(...pruebasState.map(p => parseInt(p.id))) + 1).toString()
    const pruebaWithId: Prueba = {
      ...newPrueba,
      id: newId
    }
    setPruebas(prev => [...prev, pruebaWithId])
  }

  const filteredPruebas = pruebasState.filter(prueba => {
    const searchLower = searchTerm.toLowerCase()
    return (
      prueba.nombre.toLowerCase().includes(searchLower) ||
      prueba.descripcion.toLowerCase().includes(searchLower) ||
      prueba.tipo.toLowerCase().includes(searchLower) ||
      prueba.tiempoEstimado.toLowerCase().includes(searchLower)
    )
  })

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1>Lista de Pruebas</h1>
        {isAdmin && <AddPruebaDialog onAdd={handleAddPrueba} />}
      </div>
      
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Buscar pruebas..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>
      
      {filteredPruebas.length === 0 && searchTerm ? (
        <div className="text-center py-8">
          <p className="text-muted-foreground">No se encontraron pruebas que coincidan con "{searchTerm}"</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredPruebas.map((prueba) => (
            <Card key={prueba.id}>
              <CardHeader>
                <CardTitle className="flex justify-between items-center">
                  {prueba.nombre}
                  <Badge variant={prueba.tipo === "Fisico" ? "default" : "outline"}>
                    {prueba.tipo}
                  </Badge>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div>
                    <label className="text-muted-foreground">Descripción</label>
                    <p>{prueba.descripcion}</p>
                  </div>
                  <div>
                    <label className="text-muted-foreground">Tiempo Estimado</label>
                    <p>{prueba.tiempoEstimado}</p>
                  </div>
                  {isAdmin && (
                    <EditPruebaDialog 
                      prueba={prueba} 
                      onSave={handleSavePrueba}
                    />
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}